import styled from 'styled-components'
import { Colors } from 'cio-design-library/design-tokens'
import { ButtonSize, ButtonV2 } from 'builder/components/Button'
import Typography, { FontWeights } from 'builder/styles/typography'
import { Shadows } from 'builder/styles/shadows'

export const TooltipBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
  width: 352px;
  border-radius: 16px;
  background: ${Colors.White};

  ${Shadows.lightWithBorder.high};
`

export const TooltipContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`

export const TooltipTitle = styled.div`
  color: ${Colors.Neutral90};

  ${Typography.Body};
  ${FontWeights.Medium};
`

export const TooltipSubHeader = styled.div`
  color: ${Colors.Neutral50};

  ${Typography.Caption};
  ${FontWeights.Regular};
`

export const TooltipFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const ProgressBarContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`

export const Steps = styled.div`
  color: ${Colors.Neutral50};

  ${Typography.Caption};
  ${FontWeights.Medium};
`

export const ProgressContainer = styled.div`
  width: 80px;
  height: 2px;
  background-color: ${Colors.White};
`

export const ProgressBar = styled.div<{ progress: number }>`
  height: 100%;
  width: ${({ progress }) => `${progress}%`};
  background-color: ${Colors.Blue50};
`

export const Actions = styled.div`
  display: flex;
  gap: 8px;
  margin-left: auto;
`

export const NextButton = styled(ButtonV2).attrs({
  size: ButtonSize.small,
})`
  padding: 6px;
`
